import { render } from "./BasketExpiryWarning.vue?vue&type=template&id=290451a2&scoped=true&lang=pug"
import script from "./BasketExpiryWarning.vue?vue&type=script&lang=ts"
export * from "./BasketExpiryWarning.vue?vue&type=script&lang=ts"

import "./BasketExpiryWarning.vue?vue&type=style&index=0&id=290451a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-290451a2"

export default script